import styled from "styled-components";
import MobileNav from "./Components/UI/MobileNav/MobileNav";
import DesktopNav from "./Components/UI/DesktopNav/DesktopNav";
import TopBar from "./Components/UI/TopBar/TopBar";
import StoriesContextProvider from "./Contexts/StoriesContext";
import "primereact/resources/primereact.min.css";
import "./Components/UI/Prime-React-Custom-Theme-Blue.css";
import Dialog from "./Components/UI/Dialog";
import { Outlet, useNavigate } from "react-router-dom";

import CurrentUserContextProvider from "./Contexts/CurrentUserContext";
import OrgTreeContextProvider from "./Contexts/OrgTreeContext";
import UserDatabaseContextProvider from "./Contexts/UserDatabaseContext";
import ReportDatabaseContextProvider from "./Contexts/ReportDatabaseContext";
import SpinnerContextProvider from "./Contexts/SpinnerContext";
import DialogueWindowContextProvider from "./Contexts/DialogueWindowContext";
import HotTopicsContextProvider from "./Contexts/HotTopicsContext";
import PWABanner from "./Components/UI/PWA-Banner/PWA-Banner";
import CheatSheetsContextProvider from "./Contexts/CheatSheetsContext";
import NotificationContext from "./Contexts/NotificationsContext";
import { useEffect } from "react";

const AppContentWrapper = styled.div`
  --top-bar-size: 85px;
  --mobile-break-width: 800px;
  --accent-color-dark: rgb(0, 91, 161);
  --accent-color-light: rgb(124, 160, 188);
  --relationships-color: #ff4560;
  --lifeSkills-color: #feb019;
  --health-color: #00ce89;
  --crisis-color: #0d7f6a;
  --additionalNeeds-color: #2196f3;
  --admin-color: #1a237e;
  --trauma-color: #856cd6;
  --mentalHealth-color: #f63aab;
  --personalDevelopment-color: #00d9e9;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
  width: 100vw;
  height: 100vh;

  h1 {
    color: var(--accent-color-dark);
  }
`;

const PageContent = styled.div`
  position: absolute;
  top: 85px;
  width: 100vw;
  padding-bottom: 85px;

  @media (min-width: 800px) {
    width: calc(100% - 200px);
    left: 200px;
    padding-bottom: none;
    height: calc(100vh - 85px);
  }
`;
function App() {
  const navigate = useNavigate();
  useEffect(() => {
    if (window.location.pathname === "/") {
      navigate("/overview");
    }
  }, [navigate]);

  return (
    <AppContentWrapper>
      <DialogueWindowContextProvider>
        <SpinnerContextProvider>
          <CurrentUserContextProvider>
            <OrgTreeContextProvider>
              <UserDatabaseContextProvider>
                <HotTopicsContextProvider>
                  <ReportDatabaseContextProvider>
                    <StoriesContextProvider>
                      <CheatSheetsContextProvider>
                        <NotificationContext>
                          <TopBar />
                          <DesktopNav />
                          <PageContent>
                            <Outlet />
                            <Dialog />
                          </PageContent>
                          <MobileNav />
                          <PWABanner />
                        </NotificationContext>
                      </CheatSheetsContextProvider>
                    </StoriesContextProvider>
                  </ReportDatabaseContextProvider>
                </HotTopicsContextProvider>
              </UserDatabaseContextProvider>
            </OrgTreeContextProvider>
          </CurrentUserContextProvider>
        </SpinnerContextProvider>
      </DialogueWindowContextProvider>
    </AppContentWrapper>
  );
}

export default App;
